module.exports = __webpack_public_path__ + "static/media/mvp.499fb6ab.wav";